import React from 'react';
import { CheckCircle, GraduationCap, Globe, DollarSign, FileText } from 'lucide-react';

const EligibilityRequirements = ({ eligibilityData }) => {
  const getIcon = (category) => {
    switch (category) {
      case 'Academic Requirements':
        return <GraduationCap className="w-6 h-6 text-blue-600" />;
      case 'English Proficiency':
        return <Globe className="w-6 h-6 text-green-600" />;
      case 'Financial Requirements':
        return <DollarSign className="w-6 h-6 text-yellow-600" />;
      case 'Additional Documents':
        return <FileText className="w-6 h-6 text-purple-600" />;
      default:
        return <CheckCircle className="w-6 h-6 text-gray-600" />;
    }
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {eligibilityData?.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Meet these essential requirements to begin your educational journey abroad
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {eligibilityData?.requirements?.map((requirement, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center mb-4">
                {getIcon(requirement.category)}
                <h3 className="text-xl font-semibold text-gray-900 ml-3">
                  {requirement.category}
                </h3>
              </div>
              
              <ul className="space-y-3">
                {requirement.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* <div className="mt-12 text-center">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
            <h4 className="text-lg font-semibold text-blue-900 mb-2">
              Need Help with Requirements?
            </h4>
            <p className="text-blue-700 mb-4">
              Our expert counselors can guide you through the eligibility requirements and help you prepare your application.
            </p>
            <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-200">
              Get Free Consultation
            </button>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default EligibilityRequirements;